var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"styles-button",class:{ isTransparent: _vm.isTransparentButton },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('clickHandler')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }